import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#111"
      fillRule="evenodd"
      d="M5.363 6.697c0-.418.306-.758.682-.758h12.272c.377 0 .682.34.682.758s-.305.758-.682.758H6.045c-.376 0-.682-.34-.682-.758Z"
      clipRule="evenodd"
    />
    <path
      fill="#111"
      fillRule="evenodd"
      d="M17.27 6.025c.383 0 .694.311.694.695v10.776a2.778 2.778 0 0 1-2.778 2.778H9.182a2.778 2.778 0 0 1-2.778-2.778V6.72a.694.694 0 1 1 1.39 0v10.776c0 .768.621 1.39 1.388 1.39h6.004c.767 0 1.389-.622 1.389-1.39V6.72c0-.384.31-.695.694-.695Z"
      clipRule="evenodd"
    />
    <path
      fill="#111"
      fillRule="evenodd"
      d="M16.518 6.72a.751.751 0 1 1 1.502 0v10.777a2.835 2.835 0 0 1-2.834 2.834H9.182a2.835 2.835 0 0 1-2.834-2.834V6.72a.751.751 0 0 1 1.502 0v10.777c0 .735.597 1.332 1.332 1.332h6.004c.736 0 1.332-.597 1.332-1.332V6.72Zm.751-.638a.638.638 0 0 0-.637.638v10.777c0 .798-.648 1.445-1.446 1.445H9.182a1.446 1.446 0 0 1-1.445-1.445V6.72a.638.638 0 0 0-1.276 0v10.777a2.721 2.721 0 0 0 2.721 2.72h6.004a2.721 2.721 0 0 0 2.72-2.72V6.72a.638.638 0 0 0-.637-.638Z"
      clipRule="evenodd"
    />
    <path
      fill="#111"
      fillRule="evenodd"
      d="M14.722 8.758c.383 0 .694.31.694.694v6.944a.694.694 0 0 1-1.389 0V9.453c0-.383.311-.694.695-.694ZM12.183 8.758c.383 0 .694.31.694.694v6.944a.694.694 0 0 1-1.389 0V9.453c0-.383.311-.694.695-.694ZM9.64 8.758c.383 0 .694.31.694.694v6.944a.694.694 0 0 1-1.389 0V9.453c0-.383.311-.694.695-.694ZM10.245 5.81c0-.35.283-.634.633-.634h2.586c.35 0 .634.284.634.634v.693a.755.755 0 1 0 1.51 0V5.81c0-1.184-.96-2.144-2.144-2.144h-2.586c-1.184 0-2.144.96-2.144 2.144v.693a.755.755 0 1 0 1.51 0V5.81Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgComponent
